import {
    GET_USAGE_LOG_BEGIN, GET_USAGE_LOG_SUCCESS, GET_USAGE_LOG_FAILURE,
    GET_SCORE_METRICS_BEGIN, GET_SCORE_METRICS_SUCCESS, GET_SCORE_METRICS_FAILURE,
    GET_UNIQUE_DOCUMENTS_BEGIN, GET_UNIQUE_DOCUMENTS_SUCCESS, GET_UNIQUE_DOCUMENTS_FAILURE,
    GET_SCORE_BY_DOCUMENT_BEGIN, GET_SCORE_BY_DOCUMENT_SUCCESS, GET_SCORE_BY_DOCUMENT_FAILURE,
    GET_LOGS_BY_DOCUMENT_BEGIN, GET_LOGS_BY_DOCUMENT_SUCCESS, GET_LOGS_BY_DOCUMENT_FAILURE,
    GET_SCORE_METRICS_BY_DATE_BEGIN, GET_SCORE_METRICS_BY_DATE_SUCCESS, GET_SCORE_METRICS_BY_DATE_FAILURE,
    CLEAN_USAGE_LOG_METRICS
} from '../constants/ActionTypes'

const initialState = {
    // Existing usage logs state
    isLoadingUsageLogs: false,
    hasErrorUsageLogs: null,
    usageLogsData: null,
    wasSuccessfulUsageLogs: false,

    // Score Metrics state
    isLoadingScoreMetrics: false,
    hasErrorScoreMetrics: null,
    scoreMetricsData: null,
    wasSuccessfulScoreMetrics: false,

    // Score Metrics by Date state (ADICIONADO)
    isLoadingScoreMetricsByDate: false,
    hasErrorScoreMetricsByDate: null,
    scoreMetricsByDateData: [],
    wasSuccessfulScoreMetricsByDate: false,

    // Unique Documents state
    isLoadingUniqueDocuments: false,
    hasErrorUniqueDocuments: null,
    uniqueDocumentsData: [],
    wasSuccessfulUniqueDocuments: false,

    // Score by Document state
    isLoadingScoreByDocument: false,
    hasErrorScoreByDocument: null,
    scoreByDocumentData: null,
    wasSuccessfulScoreByDocument: false,

    // Logs by Document state
    isLoadingLogsByDocument: false,
    hasErrorLogsByDocument: null,
    logsByDocumentData: [],
    wasSuccessfulLogsByDocument: false,
}

/**
 * Reducer function for managing the state of usage logs and score metrics.
 *
 * @author Isadora Botassari, pvborgesz
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @returns {Object} - The updated state.
 */
const ReducerUsageLog = (state = initialState, action) => {

    switch (action.type) {

        // Existing usage logs cases
        case GET_USAGE_LOG_BEGIN: {
            return {
                ...state,
                isLoadingUsageLogs: true,
                hasErrorUsageLogs: null,
                wasSuccessfulUsageLogs: false
            }
        }
        case GET_USAGE_LOG_SUCCESS: {
            return {
                ...state,
                usageLogsData: action.payload,
                isLoadingUsageLogs: false,
                hasErrorUsageLogs: null,
                wasSuccessfulUsageLogs: true
            }
        }
        case GET_USAGE_LOG_FAILURE: {
            return {
                ...state,
                usageLogsData: {
                    logs: []
                },
                isLoadingUsageLogs: false,
                hasErrorUsageLogs: action.payload,
                wasSuccessfulUsageLogs: false
            }
        }

        // Score Metrics cases
        case GET_SCORE_METRICS_BEGIN: {
            return {
                ...state,
                isLoadingScoreMetrics: true,
                hasErrorScoreMetrics: null,
                wasSuccessfulScoreMetrics: false
            }
        }
        case GET_SCORE_METRICS_SUCCESS: {
            return {
                ...state,
                scoreMetricsData: action.payload.data,
                isLoadingScoreMetrics: false,
                hasErrorScoreMetrics: null,
                wasSuccessfulScoreMetrics: true
            }
        }
        case GET_SCORE_METRICS_FAILURE: {
            return {
                ...state,
                scoreMetricsData: null,
                isLoadingScoreMetrics: false,
                hasErrorScoreMetrics: action.payload,
                wasSuccessfulScoreMetrics: false
            }
        }

        // Score Metrics by Date cases (ADICIONADO)
        case GET_SCORE_METRICS_BY_DATE_BEGIN: {
            return {
                ...state,
                isLoadingScoreMetricsByDate: true,
                hasErrorScoreMetricsByDate: null,
                wasSuccessfulScoreMetricsByDate: false
            }
        }
        case GET_SCORE_METRICS_BY_DATE_SUCCESS: {
            return {
                ...state,
                scoreMetricsByDateData: action.payload.data || action.payload,
                isLoadingScoreMetricsByDate: false,
                hasErrorScoreMetricsByDate: null,
                wasSuccessfulScoreMetricsByDate: true
            }
        }
        case GET_SCORE_METRICS_BY_DATE_FAILURE: {
            return {
                ...state,
                scoreMetricsByDateData: [],
                isLoadingScoreMetricsByDate: false,
                hasErrorScoreMetricsByDate: action.payload,
                wasSuccessfulScoreMetricsByDate: false
            }
        }

        // Unique Documents cases
        case GET_UNIQUE_DOCUMENTS_BEGIN: {
            return {
                ...state,
                isLoadingUniqueDocuments: true,
                hasErrorUniqueDocuments: null,
                wasSuccessfulUniqueDocuments: false
            }
        }
        case GET_UNIQUE_DOCUMENTS_SUCCESS: {
            return {
                ...state,
                uniqueDocumentsData: action.payload.data || [],
                isLoadingUniqueDocuments: false,
                hasErrorUniqueDocuments: null,
                wasSuccessfulUniqueDocuments: true
            }
        }
        case GET_UNIQUE_DOCUMENTS_FAILURE: {
            return {
                ...state,
                uniqueDocumentsData: [],
                isLoadingUniqueDocuments: false,
                hasErrorUniqueDocuments: action.payload,
                wasSuccessfulUniqueDocuments: false
            }
        }

        // Score by Document cases
        case GET_SCORE_BY_DOCUMENT_BEGIN: {
            return {
                ...state,
                isLoadingScoreByDocument: true,
                hasErrorScoreByDocument: null,
                wasSuccessfulScoreByDocument: false
            }
        }
        case GET_SCORE_BY_DOCUMENT_SUCCESS: {
            return {
                ...state,
                scoreByDocumentData: action.payload.data,
                isLoadingScoreByDocument: false,
                hasErrorScoreByDocument: null,
                wasSuccessfulScoreByDocument: true
            }
        }
        case GET_SCORE_BY_DOCUMENT_FAILURE: {
            return {
                ...state,
                scoreByDocumentData: null,
                isLoadingScoreByDocument: false,
                hasErrorScoreByDocument: action.payload,
                wasSuccessfulScoreByDocument: false
            }
        }

        // Logs by Document cases
        case GET_LOGS_BY_DOCUMENT_BEGIN: {
            return {
                ...state,
                isLoadingLogsByDocument: true,
                hasErrorLogsByDocument: null,
                wasSuccessfulLogsByDocument: false
            }
        }
        case GET_LOGS_BY_DOCUMENT_SUCCESS: {
            return {
                ...state,
                logsByDocumentData: action.payload.data || [],
                isLoadingLogsByDocument: false,
                hasErrorLogsByDocument: null,
                wasSuccessfulLogsByDocument: true
            }
        }
        case GET_LOGS_BY_DOCUMENT_FAILURE: {
            return {
                ...state,
                logsByDocumentData: [],
                isLoadingLogsByDocument: false,
                hasErrorLogsByDocument: action.payload,
                wasSuccessfulLogsByDocument: false
            }
        }

        // Clean metrics state
        case CLEAN_USAGE_LOG_METRICS: {
            return {
                ...state,
                // Reset only the new metrics, keep original usage logs
                isLoadingScoreMetrics: false,
                hasErrorScoreMetrics: null,
                scoreMetricsData: null,
                wasSuccessfulScoreMetrics: false,

                // ADICIONADO - limpar scoreMetricsByDate também
                isLoadingScoreMetricsByDate: false,
                hasErrorScoreMetricsByDate: null,
                scoreMetricsByDateData: [],
                wasSuccessfulScoreMetricsByDate: false,

                isLoadingUniqueDocuments: false,
                hasErrorUniqueDocuments: null,
                uniqueDocumentsData: [],
                wasSuccessfulUniqueDocuments: false,

                isLoadingScoreByDocument: false,
                hasErrorScoreByDocument: null,
                scoreByDocumentData: null,
                wasSuccessfulScoreByDocument: false,

                isLoadingLogsByDocument: false,
                hasErrorLogsByDocument: null,
                logsByDocumentData: [],
                wasSuccessfulLogsByDocument: false,
            }
        }

        default: return state

    }
}

export default ReducerUsageLog